import React from "react";
import RoleRoute from "./RoleRoute";

const HRProtectedRoute = ({ isHR, ...rest }) => (
    <RoleRoute roles={["HrMedical", "HrLead"]} {...rest} />
);

export default HRProtectedRoute;
